<span (click)="toggle()" (mouseenter)="!manual ? open() : null" (mouseleave)="keepOpen ? null : close()" style="cursor: default;">
  <div style="display: none">
    <div #tooltipContent>
      <ng-content select=".tooltipContent"></ng-content>
    </div>
  </div>
  <span #trigger [class]="wide ? '' : 'tooltip-normal'" data-bs-triggers="manual" data-bs-container="body"><ng-content></ng-content></span>
</span>
